module.exports = __webpack_public_path__ + "img/stand_xiaoman_cheer_cut.1528188e.png";